export const registerOptions = {
  full_name: {
    required: "مقدار نام و نام خانوادگی نباید خالی باشد",
  },
  email: {
    required: "مقدار ایمیل نباید خالی باشد",
    pattern: {
      value: /\S+@\S+\.\S+/,
      message: "ایمیل وارد شده اشتباه است",
    },
  },
  password: {
    required: "مقدار پسورد نباید خالی باشد",
    minLength: {
      value: 8,
      message: "پسورد نباید کمتر از 8 کاراکتر باشد",
    },
  },
  phone_number: {
    required: "مقدار شماره تماس نباید خالی باشد",
    pattern: {
      value: /^(0|\+98)[۰-۹0-9]{10}$/,
      message: "شماره تماس وارد شده اشتباه است",
    },
  },
  phone_number_otp: {
    required: "مقدار شماره تماس نباید خالی باشد",
    pattern: {
      value: /^(0|\+98)[۰-۹0-9]{10}$/,
      message: "شماره تماس وارد شده اشتباه است",
    },
  },
  company_name: {
    required: "آدرس زیر صفحه نباید خالی باشد",
  },
};
